// extracted by mini-css-extract-plugin
export default {"sport":"index_sport_4qj-3"};